import expandableBanner from 'html/layouts/expandable-banner.html';
import App from 'app/app.js';
import 'app/directive/LtExpandableBannerCtrl.js';

function LtExpandableBannerDirective() {
  return {
    restrict: 'E',
    scope: {
      ltShow: '='
    },
    template: expandableBanner,
    controller: 'LtExpandableBannerCtrl',
    controllerAs: 'banner'
  };
}

App.directive('ltExpandableBanner', [LtExpandableBannerDirective]);
